// extracted by css-extract-rspack-plugin
export default {"textContent":"UY568oFX","topTextContent":"IHpWs6eD"};